export default "__VITE_ASSET__Cc0SU19y__"